import { useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import PropertyFeaturesForm from '../components/PropertyFeaturesForm';
import propertiesService from '../services/propertiesService';
import './PropertyFeatures.css'; // reuse the same shell styles

function EditPropertyFeatures() {
  const navigate   = useNavigate();
  const location   = useLocation();
  const { id }     = useParams();
  const property   = location.state?.property ?? null;
  const [saving, setSaving] = useState(false);

  const handleSave = async (updatedProperty) => {
    setSaving(true);
    try {
      await propertiesService.updateProperty(id, updatedProperty);
    } catch (err) {
      console.error('Failed to save property:', err);
    } finally {
      setSaving(false);
      navigate(`/properties/${id}`);
    }
  };

  return (
    <div className="features-page">
      <PropertyFeaturesForm
        property={property}
        stepLabel="Edit: Step 2 of 2"
        saveLabel={saving ? 'Saving...' : 'Save Changes'}
        skipLabel={null}
        onSave={handleSave}
        onSkip={null}
        disabled={saving}
      />
    </div>
  );
}

export default EditPropertyFeatures;

